import { ContentWrapper } from '@/General/ContentWrapper'
import { H1 } from '@/General/H1'
import { InfoAlert } from '@/General/InfoAlert'
import { CheckoutSteps } from '../../../../checkout/CheckoutSteps'

interface RegisterErrorStateProps {
  conventionSlug: string
  brandCode: string
  hasError: boolean
}

export const RegisterErrorState = ({
  conventionSlug,
  brandCode,
  hasError,
}: RegisterErrorStateProps) => {
  return (
    <div>
      <CheckoutSteps current="cart" />
      <ContentWrapper>
        <H1>Register</H1>
        <InfoAlert variant="error" title="Unable to load registration">
          <div>
            <p className="mb-2">
              {hasError
                ? 'An error occurred while loading the convention details. Please try again later.'
                : 'No registration product was found for this URL. The segment after /magic-conventions/ must match PRODUCT.URL_STUB exactly (including year). Unpublished products are loaded automatically when the stub exists; if this persists, confirm the stub in SQL and that your app is using the same database as the API.'}
            </p>
            {process.env.NODE_ENV === 'development' && (
              <p className="text-sm mt-2 text-gray-600">
                {`Debug: ecommProductBySlug(slug: "${conventionSlug}", brandCode: "${brandCode}"). Live products return without a password; non-live stubs retry with password=productId after ecommProductAccessBySlug.`}
              </p>
            )}
          </div>
        </InfoAlert>
      </ContentWrapper>
    </div>
  )
}

